import { TradeFairRegistrationCount } from "./TradeFairRegistrations";
import { t } from '../../../libraries/i18n';
import { useMemo } from "react";
import './Totals.scss'

type Props = {
  totals: TradeFairRegistrationCount;
  totalsExpected: TradeFairRegistrationCount;
  day: string | Date | unknown;
}
export const Totals = (props: Props) => {
  const { totals, totalsExpected, day } = props;

  const totalAttendees = useMemo(() => totals.attendeesAdult + totals.attendeesChild1 + totals.attendeesChild2 + totals.attendeesChild3,
    [totals.attendeesAdult, totals.attendeesChild1, totals.attendeesChild2, totals.attendeesChild3]
  );

  const totalAttendeesExpected = useMemo(() => totalsExpected.attendeesAdult + totalsExpected.attendeesChild1 + totalsExpected.attendeesChild2 + totalsExpected.attendeesChild3,
    [totalsExpected.attendeesAdult, totalsExpected.attendeesChild1, totalsExpected.attendeesChild2, totalsExpected.attendeesChild3]
  );

  const formatDate = useMemo(() => String(day).split("-").reverse().join("-") || String(day), [day]);
  const totalGraph = useMemo(() => totalAttendeesExpected === 0 ? (totalAttendees ? '100+' : 0) : Math.round(totalAttendees / totalAttendeesExpected * 100) || 0, [totalAttendees, totalAttendeesExpected]);

  return (
    <div className="Registration-totals">
      <div className="Registration-totals__title">Registraties op {String(formatDate)}</div>
      < div className="Registration-totals__title">klanten aanwezig: <span>{totals.clients}</span>
        &nbsp;/&nbsp;
        {totalsExpected.clients} </div>

      <div className="Registration-totals__content">

        <table >
          <thead>


            <tr>
              <th>{t('events.label_quantity')}</th>
              <td style={{ textAlign: "right" }}>
                <span>{totals.attendeesAdult}</span>
                {!!totals.surPlusAttendeesAdult && <span style={{ color: '#868686' }}> + {totals.surPlusAttendeesAdult} extra</span>}
                &nbsp;/&nbsp;
                {totalsExpected.attendeesAdult}
              </td>
            </tr>

            <tr>
              <th>{t('events.label_quantity_1')}</th>
              <td style={{ textAlign: "right" }}>
                <span>{totals.attendeesChild1}</span>
                {!!totals.surPlusAttendeesChild1 && <span> + {totals.surPlusAttendeesChild1} extra</span>}
                &nbsp;/&nbsp;
                {totalsExpected.attendeesChild1}
              </td>
            </tr>
            
            <tr>
              <th>{t('events.label_quantity_2')}</th>
              <td style={{ textAlign: "right" }}>
                <span>{totals.attendeesChild2}</span>
                {!!totals.surPlusAttendeesChild2 && <span> + {totals.surPlusAttendeesChild2} extra</span>}
                &nbsp;/&nbsp;
                {totalsExpected.attendeesChild2}
              </td>
            </tr>

            <tr>
              <th>{t('events.label_quantity_3')}</th>
              <td style={{ textAlign: "right" }}>
                <span>{totals.attendeesChild3}</span>
                {!!totals.surPlusAttendeesChild3 && <span> + {totals.surPlusAttendeesChild3} extra</span>}
                &nbsp;/&nbsp;
                {totalsExpected.attendeesChild3}
              </td>
            </tr>

            <tr className="total">
              <th>Totaal</th>
              <td style={{ textAlign: "right" }}>
                <span>{totalAttendees}</span>
                {(!!totals.surPlusAttendeesAdult || !!totals.surPlusAttendeesChild1 || !!totals.surPlusAttendeesChild2 || !!totals.surPlusAttendeesChild3 ) && 
                <span style={{ color: '#868686' }}> + {(totals.surPlusAttendeesAdult || 0) + (totals.surPlusAttendeesChild1 || 0) + (totals.surPlusAttendeesChild2 || 0) + (totals.surPlusAttendeesChild3 || 0)} extra</span>}
                &nbsp;/&nbsp;
                {(totalsExpected.attendeesAdult || 0) + (totalsExpected.attendeesChild1 || 0) + (totalsExpected.attendeesChild2 || 0) + (totalsExpected.attendeesChild3 || 0)}
              </td>
            </tr>



          </thead>
        </table>

        <svg viewBox="0 0 35.83098862 35.83098862" width="100" height="100" xmlns="http://www.w3.org/2000/svg">
          <g><text className="circle-chart__percent" x="17.91549431" y="17.5" alignmentBaseline="central" textAnchor="middle" fontSize="6">{totalGraph}%</text></g>
          <circle className="circle-chart__background" stroke="#efefef" strokeWidth="4" fill="none" cx="17.91549431" cy="17.91549431" r="15.91549431" />
          <circle className="circle-chart__circle" stroke="#c1ad76" strokeWidth="4" strokeDasharray={`${totalGraph}, 100`} strokeLinecap={undefined} fill="none" cx="17.91549431" cy="17.91549431" r="15.91549431" />
        </svg>
      </div>


    </div>
  );
}